var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgOrganizationUnActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#2D81F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1043 16.3184H20.0103C20.1218 16.6237 20.1827 16.9531 20.1827 17.2966V21.4313C20.1827 21.5745 20.1578 21.7119 20.1124 21.8397H21.9211C22.5967 21.8397 23.1463 21.2901 23.1463 20.6145V18.3604C23.1464 17.2344 22.2303 16.3184 21.1043 16.3184Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9637 17.2966C11.9637 16.9531 12.0246 16.6237 12.1361 16.3184H11.0421C9.91608 16.3184 9 17.2344 9 18.3605V20.6145C9 21.2901 9.54963 21.8398 10.2253 21.8398H12.0339C11.9886 21.7119 11.9637 21.5745 11.9637 21.4313V17.2966Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3239 15.2544H14.8229C13.6968 15.2544 12.7808 16.1705 12.7808 17.2965V21.4313C12.7808 21.6568 12.9636 21.8397 13.1892 21.8397H18.9576C19.1832 21.8397 19.366 21.6568 19.366 21.4313V17.2965C19.366 16.1705 18.45 15.2544 17.3239 15.2544Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0731 9.83984C14.7189 9.83984 13.6172 10.9415 13.6172 12.2957C13.6172 13.2143 14.1242 14.0165 14.8729 14.4377C15.228 14.6375 15.6374 14.7516 16.0731 14.7516C16.5087 14.7516 16.9181 14.6375 17.2733 14.4377C18.022 14.0165 18.5289 13.2143 18.5289 12.2957C18.5289 10.9416 17.4272 9.83984 16.0731 9.83984Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7605 12.1289C10.7477 12.1289 9.92383 12.9528 9.92383 13.9656C9.92383 14.9783 10.7477 15.8023 11.7605 15.8023C12.0174 15.8023 12.262 15.749 12.4843 15.6534C12.8685 15.488 13.1853 15.1951 13.3813 14.8284C13.5189 14.5709 13.5972 14.2773 13.5972 13.9656C13.5972 12.9528 12.7733 12.1289 11.7605 12.1289Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3855 12.1289C19.3727 12.1289 18.5488 12.9528 18.5488 13.9656C18.5488 14.2773 18.6271 14.571 18.7647 14.8284C18.9607 15.1952 19.2775 15.488 19.6617 15.6534C19.884 15.749 20.1286 15.8023 20.3855 15.8023C21.3983 15.8023 22.2222 14.9783 22.2222 13.9656C22.2222 12.9528 21.3983 12.1289 20.3855 12.1289Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOrganizationUnActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/organization-un-active.d88a3287.svg";
export { ForwardRef as ReactComponent };